let moduleName = 'angular-character-count';

angular.module(moduleName, [])
    .directive('charCount', ['$parse', '$compile', function ($parse, $compile) {
        return {
            require: 'ngModel',

            link: function (scope, element, attr, ngModel) {
                let idP = Math.round(Math.random() * 1000000000);
                $(element).after('<p class="sw-form-charcount" id=' + idP + '>' + element[0].selectionEnd + ' / ' + attr.maxCount + '</p>');
                scope.$watch(function () {
                        return ngModel.$viewValue;
                    },
                    function (newValue) {
                        console.log('attr.isRequired', attr.isRequired);
                        if (angular.isDefined(newValue)) {
                            console.log('here');
                            let remainingChar = newValue.length;
                            let remainingSpan = '<p class="sw-form-charcount">' + remainingChar + ' / ' + attr.maxCount + '</p>';
                            $('#' + idP).html(remainingSpan);

                            if (attr.isRequired === 'true') {
                                if (remainingChar > parseInt(attr.warningCount) && remainingChar > parseInt(attr.dangerCount)) {
                                    $('#' + idP).removeClass('warningCharacter');
                                    $('#' + idP).removeClass('dangerCharacter');
                                    $('#' + idP).addClass('normalCharacter');
                                } else {
                                    if (remainingChar <= parseInt(attr.warningCount) && remainingChar > parseInt(attr.dangerCount)) {
                                        $('#' + idP).addClass('warningCharacter');
                                        $('#' + idP).removeClass('dangerCharacter');
                                        $('#' + idP).removeClass('normalCharacter');
                                    } else {
                                        $('#' + idP).removeClass('warningCharacter');
                                        $('#' + idP).removeClass('normalCharacter');
                                        $('#' + idP).addClass('dangerCharacter');
                                    }
                                }
                            }
                        }
                    }
                );
            }
        };
    }
]);

export default moduleName;



// WEBPACK FOOTER //
// ./src/app/directives/charcountDirective.js